<cb-dialog>
    <form class="flex-col flex"
          #bundleTemplateForm="ngForm">
        <cb-input type="text"
                  name="name"
                  label="Name"
                  [required]="true"
                  [(ngModel)]="mappedItem.name">
        </cb-input>
        <cb-checkbox name="isActive"
                     label="Is Active"
                     [(ngModel)]="mappedItem.isActive">
        </cb-checkbox>
        <cb-select-items-dialog name="bundleItems"
                                [(ngModel)]="mappedItem.bundleItems"
                                [columnsValues]="columns"
                                [columnsNames]="columnsNames"
                                [newEmptyItem]="$any(newEmptyItem)"
                                label="Bundle Template Items">
        </cb-select-items-dialog>
    </form>
    <div actions>
        <span class="flex"></span>
        <button mat-raised-button
                class="save-button"
                color="primary"
                (click)="save()"
                [disabled]="!bundleTemplateForm.dirty || !bundleTemplateForm.valid">
            Save
        </button>
        <button mat-raised-button
                (click)="cancel()">
            Cancel
        </button>
    </div>
</cb-dialog>
